import base from "../../baseurl";
import token from "../../getTk";

const Create = async (eventId) => {
  //console.log(state)
  const tokenA = token.get();
  const api = base.extend({
    hooks: {
      beforeRequest: [
        (request) => {
          request.headers.set("jwt", `${tokenA}`);
        },
      ],
    },
  });
  const Update = await api
    .post("event-participants/showall", {
      timeout: false,
      json: { eventId },
    })
    .json();

  return Update;
};

export default Create;
